import Coolvetica from "../../assets/fonts/Coolvetica/coolvetica_rg.ttf";
import Coolvetica_ttf from "../../assets/fonts/Coolvetica/coolvetica_rg.ttf";
import Coolvetica_eot from "../../assets/fonts/Coolvetica/CoolveticaRg-Regular.eot";
import Coolvetica_woff2 from "../../assets/fonts/Coolvetica/CoolveticaRg-Regular.woff2";
import Coolvetica_woff from "../../assets/fonts/Coolvetica/CoolveticaRg-Regular.woff";
import Coolvetica_svg from "../../assets/fonts/Coolvetica/CoolveticaRg-Regular.svg";

import CoolveticaLight_ttf from "../../assets/fonts/Coolvetica/CoolveticaUl-Regular.ttf";
import CoolveticaLight_eot from "../../assets/fonts/Coolvetica/CoolveticaUl-Regular.eot";
import CoolveticaLight_woff2 from "../../assets/fonts/Coolvetica/CoolveticaUl-Regular.woff2";
import CoolveticaLight_woff from "../../assets/fonts/Coolvetica/CoolveticaUl-Regular.woff";
import CoolveticaLight_svg from "../../assets/fonts/Coolvetica/CoolveticaUl-Regular.svg";

import CoolveticaCondensed_ttf from "../../assets/fonts/Coolvetica/coolvetica_condensed_rg.ttf";
import CoolveticaCondensed_eot from "../../assets/fonts/Coolvetica/CoolveticaCondensedRg-Regular.eot";
import CoolveticaCondensed_woff from "../../assets/fonts/Coolvetica/CoolveticaCondensedRg-Regular.woff";
import CoolveticaCondensed_woff2 from "../../assets/fonts/Coolvetica/CoolveticaCondensedRg-Regular.woff2";
import CoolveticaCondensed_svg from "../../assets/fonts/Coolvetica/CoolveticaCondensedRg-Regular.svg";

import CoolveticaCompressed_ttf from "../../assets/fonts/Coolvetica/coolvetica_compressed_rg.ttf";
import CoolveticaCompressed_eot from "../../assets/fonts/Coolvetica/CoolveticaCompressedRg-Regular.eot";
import CoolveticaCompressed_woff from "../../assets/fonts/Coolvetica/CoolveticaCompressedRg-Regular.woff";
import CoolveticaCompressed_woff2 from "../../assets/fonts/Coolvetica/CoolveticaCompressedRg-Regular.woff2";
import CoolveticaCompressed_svg from "../../assets/fonts/Coolvetica/CoolveticaCompressedRg-Regular.svg";

import CoolveticaCrammed_ttf from "../../assets/fonts/Coolvetica/coolvetica_crammed_rg.ttf";
import CoolveticaCrammed_eot from "../../assets/fonts/Coolvetica/CoolveticaCrammedRg-Regular.eot";
import CoolveticaCrammed_woff from "../../assets/fonts/Coolvetica/CoolveticaCrammedRg-Regular.woff";
import CoolveticaCrammed_woff2 from "../../assets/fonts/Coolvetica/CoolveticaCrammedRg-Regular.woff2";
import CoolveticaCrammed_svg from "../../assets/fonts/Coolvetica/CoolveticaCrammedRg-Regular.svg";

export const FontCoolvetica = `
  // @font-face {
  //   font-family: 'Coolvetica';
  //   src: url(${Coolvetica}) format('truetype');
  //   font-weight: 300;
  //   font-style: normal;
  // }

  @font-face {
    font-family: 'Coolvetica Crammed';
    src: url('${CoolveticaCrammed_eot}');
    src: url('${CoolveticaCrammed_eot}?#iefix') format('embedded-opentype'),
        url('${CoolveticaCrammed_woff2}') format('woff2'),
        url('${CoolveticaCrammed_woff}') format('woff'),
        url(${CoolveticaCrammed_ttf}) format('truetype');
        url('${CoolveticaCrammed_svg}#CoolveticaCrammedRg-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

@font-face {
    font-family: 'Coolvetica';
    src: url(${Coolvetica_eot});
    src: url('${Coolvetica_eot}?#iefix') format('embedded-opentype'),
        url(${Coolvetica_woff2}) format('woff2'),
        url(${Coolvetica_woff}) format('woff'),
        url(${Coolvetica_ttf}) format('truetype');
        url('${Coolvetica_svg}#CoolveticaRg-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Coolvetica Ul';
    src: url('${CoolveticaLight_eot}');
    src: url('${CoolveticaLight_eot}?#iefix') format('embedded-opentype'),
        url('${CoolveticaLight_woff2}') format('woff2'),
        url('${CoolveticaLight_woff}') format('woff'),
        url(${CoolveticaLight_ttf}) format('truetype');
        url('${CoolveticaLight_svg}#CoolveticaUl-Regular') format('svg');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Coolvetica Condensed';
    src: url('${CoolveticaCondensed_eot}');
    src: url('${CoolveticaCondensed_eot}?#iefix') format('embedded-opentype'),
        url('${CoolveticaCondensed_woff2}') format('woff2'),
        url('${CoolveticaCondensed_woff}') format('woff'),
        url(${CoolveticaCondensed_ttf}) format('truetype');
        url('${CoolveticaCondensed_svg}#CoolveticaCondensedRg-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Coolvetica Compressed';
    src: url('${CoolveticaCompressed_eot}');
    src: url('${CoolveticaCompressed_eot}?#iefix') format('embedded-opentype'),
         url('${CoolveticaCompressed_woff2}') format('woff2'),
         url('${CoolveticaCompressed_woff}') format('woff'),
          url(${CoolveticaCompressed_ttf}) format('truetype');
         url('${CoolveticaCompressed_svg}#CoolveticaCompressedRg-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

`;